console.info('Hello world');

// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';


const date = new Date();

const currentyear = date.getFullYear();
const yearfooter = document.querySelector(".dateyear");
yearfooter.textContent = currentyear;